import React, { useEffect, useState } from "react";
import { useMessageModal } from "../admin/contexts/MessageModalContext";
import LatestNews from "./LatestNews";
import ContactSection from "./ContactSection";
import BookDemoModal from "../components/BookDemoModal";
import WhatWeDo from "./WhatWeDo";
import "../assets/style.css";
import "../assets/services.css";

interface SoftwareItem {
  id: number;
  title: string;
  description: string;
  image: string | null;
  alt_text: string | null;
  video_link: string | null;
  sort_order: number;
  status: string;
}

const BASE_URL =
  import.meta.env.VITE_LYRAZONE_BASE_URL || "http://localhost:5000/api";
const IMAGE_URL =
  import.meta.env.VITE_LYRAZONE_IMAGE_URL || "http://localhost:5000/uploads";

const Software: React.FC = () => {
  const [softwareList, setSoftwareList] = useState<SoftwareItem[]>([]);
  const [loading, setLoading] = useState(true);
  const { showModal } = useMessageModal();

  const storedUser = JSON.parse(
    localStorage.getItem("subscriber_user") || "null",
  );

  const [bookDemoOpen, setBookDemoOpen] = useState(false);
  const [selectedSoftware, setSelectedSoftware] = useState<{
    id: number;
    title: string;
  } | null>(null);

  const handleProtectedBookDemo = (software: SoftwareItem) => {
    if (!storedUser) {
      showModal({
        type: "warning",
        title: "Warning",
        message: "You are not logged in, please login first.",
      });
      return;
    }

    setSelectedSoftware({
      id: software.id,
      title: software.title,
    });

    setBookDemoOpen(true);
  };

  const buttonStyle: React.CSSProperties = {
    display: "inline-block",
    textAlign: "center",
    height: "40px",
    lineHeight: "40px",
    padding: "0 15px",
  };

  const getDelay = (index: number) => {
    const delays = ["0.4s", "0.6s", "0.8s", "1s", "1.2s", "1.4s"];
    return delays[index] || "0.4s";
  };

  const getSoftwareImage = (image: string | null) => {
    if (!image) {
      return "src/assets/img/saas/elbs-erp.jpg";
    }

    if (image.startsWith("http")) {
      return image;
    }

    return `${IMAGE_URL}/uploads/software/${image}`;
  };

  const fetchSoftware = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/software/website`);
      const result = await res.json();

      if (result.success) {
        setSoftwareList(result.data || []);
      }
    } catch (error) {
      console.error("Fetch Software Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSoftware();
  }, []);

  return (
    <>
      {/* ====================================================
                        HOME-P
      ====================================================== */}
      <div id="home-p" className="home-p pages-head6 text-center">
        <div className="container">
          {/* <h1 className="wow fadeInUp" data-wow-delay="0.1s">
            Lyra Zone is fully equiped with ICT Tools
          </h1>
          <p>SOFTWARE SOLUTIONS</p> */}
        </div>
      </div>

      <section id="comp-offer" className="container-fluid">
        <div className="row">
          {loading ? (
            <div className="col-12 text-center py-5">
              <p>Loading software...</p>
            </div>
          ) : softwareList.length > 0 ? (
            softwareList.map((software, index) => (
              <div
                key={software.id}
                className="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
                data-wow-delay={getDelay(index)}
              >
                <div className="desc-comp-offer-cont">
                  <div className="thumbnail-blogs">
                    <div className="caption">
                      {software.video_link ? (
                        <a
                          href={software.video_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa fa-chain"></i>
                        </a>
                      ) : (
                        <a href="#GitForm">
                          <i className="fa fa-chain"></i>
                        </a>
                      )}
                    </div>

                    <img
                      src={getSoftwareImage(software.image)}
                      className="img-fluid"
                      alt={software.alt_text || software.title}
                    />
                  </div>

                  <h3>{software.title}</h3>

                  <p className="desc">{software.description}</p>

                  {software.video_link ? (
                    <a
                      href={software.video_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-arrow-circle-o-right"></i> Watch Video
                    </a>
                  ) : (
                    <a href="#GitForm">
                      <i className="fa fa-arrow-circle-o-right"></i> Watch Video
                    </a>
                  )}

                  {/* <a
                    className="btn btn-general btn-silver"
                    role="button"
                    style={buttonStyle}
                    onClick={() =>
                      handleProtectedNavigation("/subscriber-profile")
                    }
                  >
                    Book a Demo
                  </a> */}
                  <button
                    type="button"
                    className="btn btn-general btn-silver"
                    style={buttonStyle}
                    onClick={() => handleProtectedBookDemo(software)}
                  >
                    &nbsp;&nbsp;&nbsp;Book a Demo&nbsp;&nbsp;&nbsp;
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <p>No software available at the moment.</p>
            </div>
          )}
        </div>
      </section>

      <WhatWeDo />
      <ContactSection />
      <LatestNews />
      <BookDemoModal
        isOpen={bookDemoOpen}
        onClose={() => setBookDemoOpen(false)}
        software={selectedSoftware}
      />
    </>
  );
};

export default Software;
